import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

export interface ObjetivoSalvar {
  sellerId: number;
  nome: string;
  dataInicial: string;
  dataFinal: string;
  objetivo: number;
  premiacaoValor: number | null;
  premiacaoDescricao: string;
  versao?: string;
}
export interface Objetivo extends ObjetivoSalvar {
  id: number;
  vendedor: string;
  unidade: string;
  calculoLiberado: boolean;
  situacao: string;
  apuracao: string;
  realizado: number | null;
  percentual: number | null;
  falta: number | null;
}
export interface ObjetivosLista {
  podeGerenciar: boolean;
  vendedores: { id: number; nome: string }[];
  objetivos: Objetivo[];
}
@Injectable({ providedIn: 'root' })
export class DashboardObjetivosService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}
  private get headers() { return new HttpHeaders({ 'X-Objetivos-Token': localStorage.getItem('dashboard_objetivos_token') || '' }); }
  listar(inicio: string, fim: string, sellerId: number | null) {
    let params = new HttpParams().set('inicio', inicio).set('fim', fim);
    if (sellerId != null) params = params.set('sellerId', sellerId);
    return this.http.get<ObjetivosLista>(this.baseUrl + 'api/DashboardObjetivos', { headers: this.headers, params });
  }
  salvar(id: number | null, dados: ObjetivoSalvar) {
    return id == null
      ? this.http.post<{ id: number }>(this.baseUrl + 'api/DashboardObjetivos', dados, { headers: this.headers })
      : this.http.put<{ id: number }>(this.baseUrl + 'api/DashboardObjetivos/' + id, dados, { headers: this.headers });
  }
  desativar(item: Objetivo) {
    return this.http.delete(this.baseUrl + 'api/DashboardObjetivos/' + item.id,
      { headers: this.headers, params: new HttpParams().set('versao', item.versao) });
  }
}
